"use strict";
(function (Drupal, once) {
    Drupal.behaviors.scrollToFirstSection = {
        attach: function (context) {
            once('scrollToFirstSection', '.js-explore-more-button', context).forEach(function (element) {
                // Get the landing page sections wrapper
                const landingPageSections = document.querySelector('.js-landing-page-sections');
                // Get the site header
                const siteHeader = document.querySelector('.js-site-header');
                // Get the height of the site header
                const siteHeaderHeight = siteHeader === null || siteHeader === void 0 ? void 0 : siteHeader.clientHeight;
                element.addEventListener('click', function (event) {
                    // Get the first child of the landing page sections
                    const firstSection = landingPageSections === null || landingPageSections === void 0 ? void 0 : landingPageSections.firstElementChild;
                    // Get top position value of first section
                    const firstSectionYCord = firstSection === null || firstSection === void 0 ? void 0 : firstSection.getBoundingClientRect();
                    /**
                     * Scrolls the window to the first section of the landing page.
                     * The scroll position is adjusted to account for the height of the site header.
                     * The scroll behavior is smooth.
                     *
                     * @remarks
                     * This function is called when the element with the '.js-explore-more-button' class is clicked.
                     *
                     * @param firstSectionYCord - The DOMRect object for the first section of the landing page.
                     * @param siteHeaderHeight - The height of the site header.
                     */
                    if (firstSectionYCord && siteHeaderHeight) {
                        window.scrollTo({
                            top: firstSectionYCord.top - siteHeaderHeight,
                            behavior: 'smooth',
                        });
                    }
                });
            });
        },
    };
})(Drupal, once);
